module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui container"
  }, [_c('h1', {
    staticClass: "ui dividing header"
  }, [_vm._v("Accordion")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h3', {
    staticClass: "ui dividing header"
  }, [_vm._v("Example")]), _vm._v(" "), _c('accordion', {
    attrs: {
      "accordionId": "accordion-example",
      "customClass": "styled"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "dropdown icon"
  }), _vm._v("\n            Item 1\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("Hello, I'm the first item.")])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "dropdown icon"
  }), _vm._v("\n            Item 2\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("Hello, I'm the second item.")])])]), _vm._v(" "), _c('h3', {
    staticClass: "ui dividing header"
  }, [_vm._v("Usage")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h3', {
    staticClass: "ui dividing header"
  }, [_vm._v("Props")]), _vm._v(" "), _vm._m(3)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Accordion component,\n        "), _c('a', {
    attrs: {
      "href": "https://semantic-ui.com/modules/accordion.html"
    }
  }, [_vm._v("you can see all documentation here")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui segment"
  }, [_c('pre', [_vm._v("\n        import { Accordion } from 'semvue';\n\n        export default {\n            components: {\n                Accordion,\n            },\n        }\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui segment"
  }, [_c('pre', [_vm._v("\n        <accordion>\n            <div class=\"title\">\n                <i class=\"dropdown icon\"></i>\n                Item 1\n            </div>\n            <div class=\"content\">\n                <p>Hello, I'm the first item.</p>\n            </div>\n            <div class=\"title\">\n                <i class=\"dropdown icon\"></i>\n                Item 2\n            </div>\n            <div class=\"content\">\n                <p>Hello, I'm the second item.</p>\n            </div>\n        </accordion>\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "ui definition table"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Required")]), _vm._v(" "), _c('th', [_vm._v("Default")]), _vm._v(" "), _c('th', [_vm._v("Description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("accordionId")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("Yes")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("Is a div id for accordion")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("curstomClass")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("No")]), _vm._v(" "), _c('td', [_vm._v("String empty")]), _vm._v(" "), _c('td', [_vm._v("Used to put any aditional class inside accordion div "), _c('br'), _vm._v("\n                    e.g. class=\"ui customClass accordion\"\n                ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("options")]), _vm._v(" "), _c('td', [_vm._v("Object")]), _vm._v(" "), _c('td', [_vm._v("No")]), _vm._v(" "), _c('td', [_vm._v("Object empty")]), _vm._v(" "), _c('td', [_vm._v("Overrides component options."), _c('a', {
    attrs: {
      "href": "https://semantic-ui.com/modules/accordion.html"
    }
  }, [_vm._v(" You can see all options here")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3515ab30"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccordionDoc.vue
// module id = 144
// module chunks = 1